export enum TransactionStatus {
  PENDING = "PENDING",
  PRE_AUTHORIZED = "PRE_AUTHORIZED",
  VOID = "VOID",
  SUBMITTED_FOR_SETTLEMENT = "SUBMITTED_FOR_SETTLEMENT",
  SETTLED = "SETTLED",
  REFUNDED = "REFUNDED",
  FAILED = "FAILED",
  SETTLING = "SETTLING",
  UNKNOWN = "UNKNOWN"
}

export const AmountEditDisabledTransactionStatus: Array<TransactionStatus> = [
  TransactionStatus.PRE_AUTHORIZED,
  TransactionStatus.SUBMITTED_FOR_SETTLEMENT
];

export const PaymentSuccessTransactionSubSet: Array<TransactionStatus> = [
  TransactionStatus.SUBMITTED_FOR_SETTLEMENT,
  TransactionStatus.SETTLED,
  TransactionStatus.SETTLING
];
